import React from 'react'
import PropTypes from 'prop-types';
import classnames from 'classnames'
import moment from 'moment'

import { Button, DropdownButton, MenuItem } from 'react-bootstrap'
import { ListItem, Flex } from '~/views'
import DeviceIndicator from './DeviceIndicator'

import style from './style.css'
import { BlueprintActions } from '../../actions';

export default class DeviceItem extends React.Component {
  
  static START_EVENT = 'startDevice';

  static PAUSE_EVENT = 'pauseDevice';

  static RESET_EVENT = 'resetDevice';

  static REMOVE_EVENT = 'removeDevice';

  static OPEN_LOG_EVENT = 'openDeviceLog';

  static SIM_CONTROL_EVENT = 'openSimControl';

  static HISTORY_EVENT = 'openHistory';

  static DUPLICATE_DEVICE_EVENT = 'duplicateDevice';

  static propTypes = {
    item : PropTypes.object.isRequired,
    blueprints : PropTypes.object,
    networks : PropTypes.object,
    onEvent : PropTypes.func,
    selected : PropTypes.bool
  }

  onEvent( event ) {
    if ( this.props.onEvent ) { 
      this.props.onEvent( event, this.props.item );
    }
  }

  render() {
    const { item, networks, blueprints } = this.props;
    const blueprint = item.blueprintId && blueprints && blueprints.index[item.blueprintId]
    const net = item.networkId && networks && networks.index[item.networkId]
    const nVals = net && item.networkAliases && item.networkAliases[net.id]
    let uuid = null

    if ( net && net.aliasKeys && nVals ) {
      let keys
      if ( Array.isArray( net.aliasKeys ) ) {
        keys = net.aliasKeys
      } else if ( net.aliasKeys instanceof String || typeof net.aliasKeys === 'string' ) {
        keys = net.aliasKeys.split( ',' )
      } else {
        keys = []
      }
      // let keys = net.aliasKeys.split(',' )
      if ( keys.length == 1 ) {
        uuid = nVals[keys[0]]
      } else {
        for ( let n = 0; n < keys.length; n++ ) {
          if ( nVals[keys[n]] ) {
            uuid = `${keys[n]} : ${nVals[keys[n]]}`
            break
          }
        }
      }
    }

    return (
      <ListItem className={style.deviceItem} 
        onEvent={this.props.onEvent}
        item={item}
        selected={this.props.selected}
        title={item.name}
        subtitle={(
          <div style={{ paddingLeft : '10px' }}>
            {blueprint ? (
              <div> 
                {' '}
                <i className="fa-lg fa-fw fa fa-atom" /> 
                {' '}
                {blueprint.name}
              </div>
            ) : null }
            <div>
              <i className="fa fa-lg fa-fw fa-clock-o" /> 
              {' '}
              {moment( item.lastModified ).fromNow()}
            </div>
            {net ? (
              <div style={{ whiteSpace : 'normal' }}>
                <i className="fa fa-wifi fa-lg fa-fw" />
                {net.name}
                {uuid ? ` | ${uuid}` : ''}
              </div>
            ) : null}

          </div>
        )}
        leftView={this.renderLeft( item )}
        rightView={this.renderRight( item )} />
    )
  }

  renderLeft( device ) {
    return (
      <i className={classnames( style.leftIcon,
        device.simNetworkId != null ? 'fa fa-bolt' : 
          device.purpose === 'organization' ? 'fa fa-object-group' : 'fa fa-microchip' )} />
    );
  }

  renderRight( device ) {
    let status, options;
    const history = (
      <Button bsStyle="link"
        bsSize="large"
        className={style.reset} 
        onClick={() => { this.onEvent( DeviceItem.HISTORY_EVENT ) }}> 
        <i className="fa fa-history" /> 
      </Button>
    )
    const control = (
      <Button bsStyle="link"
        bsSize="large"
        className={style.reset} 
        onClick={() => { this.onEvent( DeviceItem.SIM_CONTROL_EVENT ) }}> 
        <i className="fa fa-sliders" /> 
      </Button>
    );

    const duplicate = ( 
      <MenuItem bsStyle="link"
        bsSize="large"
        className={style.deviceButton} 
        onClick={() => { this.onEvent( DeviceItem.DUPLICATE_DEVICE_EVENT ) }}> 
        <i className="fa fa-clone fa-fw" />
        {' '}
        Duplicate 
      </MenuItem>
    )
    const remove = ( 
      <MenuItem bsStyle="link"
        bsSize="large"
        className={style.deviceButton} 
        onClick={() => { this.onEvent( DeviceItem.REMOVE_EVENT ) }}> 
        <i className="fa fa-times fa-fw" />
        {' '}
        Delete 
      </MenuItem>
    )
    const simulated = device.simNetworkId != null

    if ( simulated ) {
      status = <DeviceIndicator device={device} />
        
      const pause = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.pause} 
          onClick={() => { this.onEvent( DeviceItem.PAUSE_EVENT ) }}> 
          <i className="fa fa-pause fa-fw" />
          {' '}
          Pause
        </MenuItem>
      )
      const start = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.pause} 
          onClick={() => { this.onEvent( DeviceItem.START_EVENT ) }}> 
          <i className="fa fa-play fa-fw" />
          {' '}
          Start
        </MenuItem>
      )
      const reset = (
        <MenuItem bsStyle="link"
          bsSize="large"
          className={style.reset} 
          onClick={() => { this.onEvent( DeviceItem.RESET_EVENT ) }}> 
          <i className="fa fa-repeat fa-fw" />
          {' '}
          Reset
        </MenuItem>
      );
        // log = (
        //   <Button bsStyle="link" bsSize="large" className={style.reset} 
        //      onClick={()=>{this.onEvent( DeviceItem.OPEN_LOG_EVENT )}} > 
        //     <i className="fa fa-file-text-o"></i> 
        //   </Button> );
        
      options = (
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={device.id} id={`options-${device.id}`}>
          {start}
          {pause}
          {reset}
          <MenuItem divider />
          {duplicate}
          <MenuItem divider />
          {remove}
        </DropdownButton>
      )
    } else {
      options = (
        <DropdownButton pullRight bsStyle="link" title={<i className="fa fa-gear fa-lg fa-fw" />} key={device.id} id={`options-${device.id}`}>
          {duplicate}
          <MenuItem divider />
          {remove}
        </DropdownButton>
      )
      /*
      options = ( 
          <Button bsStyle="link" bsSize="large" className={style.deviceButton} 
                onClick={()=>{this.onEvent( DeviceItem.REMOVE_EVENT )}} > 
            <i className="fa fa-times fa-fw"></i> 
          </Button>)
          */
    }
    return (
      <div>
        {history}
        {status}
        {control}
        {options}    
      </div>
    )
  }

}
